import type { PoNumberFormat } from '@quotetome/materials-api'

export default function usePoNumberFormats(companyId?: number) {
  const nuxtApp = useNuxtApp()
  const formats = ref<PoNumberFormat[]>([])

  const authStore = useAuthStore()
  const isStaff = authStore.isStaff
  const fetchFormats = (company?: number) => {
    let params

    if (isStaff) {
      if (!company) {
        return
      }

      params = { company }
    }

    nuxtApp.$api.v1.poNumbers.list(params)
      .then(data => { formats.value = data })
      .catch(nuxtApp.$error.report)
  }

  onMounted(() => fetchFormats(companyId))

  return { fetchFormats, formats }
}
